var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDolos = function SvgDolos(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 95.77713,
    y1: 27.732309,
    x2: 95.77713,
    y2: 93.12188,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 73.202118,
    y1: 49.861191,
    x2: 73.202118,
    y2: 130.437805,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 84.489632,
    y1: 16.52544,
    x2: 84.489632,
    y2: 147.928055,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9293154"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 38.359375 11.640625 L 35.546875 8.359375 C 35.390625 8.203125 35.078125 8.203125 34.921875 8.359375 L 32.109375 11.640625 C 31.875 11.875 32.109375 12.265625 32.421875 12.265625 L 34.375 12.265625 L 34.375 24.921875 C 34.375 25.78125 33.671875 26.484375 32.8125 26.484375 L 17.96875 26.484375 C 17.5 26.484375 17.1875 26.796875 17.1875 27.265625 C 17.1875 27.734375 17.5 28.046875 17.96875 28.046875 L 32.8125 28.046875 C 34.53125 28.046875 35.9375 26.640625 35.9375 24.921875 L 35.9375 12.265625 L 38.125 12.265625 C 38.4375 12.265625 38.59375 11.875 38.359375 11.640625 Z M 38.359375 11.640625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 31.171875 20.390625 L 16.328125 20.390625 C 14.609375 20.390625 13.203125 21.796875 13.203125 23.515625 L 13.203125 36.171875 L 11.015625 36.171875 C 10.703125 36.171875 10.46875 36.5625 10.703125 36.796875 L 13.515625 40.078125 C 13.671875 40.234375 13.984375 40.234375 14.140625 40.078125 L 16.953125 36.796875 C 17.1875 36.5625 16.953125 36.171875 16.640625 36.171875 L 14.6875 36.171875 L 14.6875 23.515625 C 14.6875 22.65625 15.390625 21.953125 16.25 21.953125 L 31.09375 21.953125 C 31.5625 21.953125 31.875 21.640625 31.875 21.171875 C 31.875 20.703125 31.5625 20.390625 31.171875 20.390625 Z M 31.171875 20.390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 41.5625 10.9375 L 37.109375 5.546875 C 36.640625 5 36.015625 4.6875 35.3125 4.6875 C 34.609375 4.6875 33.984375 5 33.515625 5.546875 L 28.984375 10.9375 C 28.359375 11.640625 28.28125 12.578125 28.671875 13.4375 C 29.0625 14.296875 29.84375 14.765625 30.78125 14.765625 L 31.25 14.765625 L 31.25 17.1875 L 16.328125 17.1875 C 12.890625 17.1875 10.078125 20 10.078125 23.4375 L 10.078125 33.59375 L 9.375 33.59375 C 8.4375 33.59375 7.65625 34.140625 7.265625 34.921875 C 6.875 35.703125 7.03125 36.796875 7.578125 37.5 L 12.03125 42.890625 C 12.5 43.4375 13.125 43.75 13.828125 43.75 C 14.53125 43.75 15.15625 43.4375 15.625 42.890625 L 20.078125 37.5 C 20.703125 36.796875 20.78125 35.859375 20.390625 35 C 20 34.140625 19.21875 33.671875 18.28125 33.671875 L 17.8125 33.671875 L 17.8125 31.25 L 32.8125 31.25 C 36.25 31.25 39.0625 28.4375 39.0625 25 L 39.0625 14.84375 L 39.765625 14.84375 C 40.703125 14.84375 41.484375 14.296875 41.875 13.515625 C 42.265625 12.734375 42.109375 11.640625 41.5625 10.9375 Z M 18.359375 35.234375 C 18.828125 35.234375 18.984375 35.546875 19.0625 35.703125 C 19.140625 35.78125 19.21875 36.171875 18.984375 36.5625 L 14.53125 41.953125 C 14.296875 42.1875 14.0625 42.265625 13.90625 42.265625 C 13.75 42.265625 13.515625 42.265625 13.28125 41.953125 L 8.828125 36.5625 C 8.515625 36.171875 8.671875 35.859375 8.75 35.703125 C 8.828125 35.625 8.984375 35.234375 9.453125 35.234375 L 10.9375 35.234375 C 11.40625 35.234375 11.71875 34.921875 11.71875 34.453125 L 11.71875 23.515625 C 11.71875 20.9375 13.828125 18.828125 16.40625 18.828125 L 31.25 18.828125 L 31.25 23.4375 L 17.1875 23.4375 C 16.953125 23.4375 16.71875 23.515625 16.640625 23.671875 C 16.484375 23.828125 16.328125 24.0625 16.328125 24.296875 L 16.328125 34.453125 C 16.328125 34.921875 16.640625 35.234375 17.109375 35.234375 Z M 40.46875 12.8125 C 40.390625 12.890625 40.234375 13.28125 39.765625 13.28125 L 38.28125 13.28125 C 37.8125 13.28125 37.5 13.59375 37.5 14.0625 L 37.5 25 C 37.5 27.578125 35.390625 29.6875 32.8125 29.6875 L 17.96875 29.6875 L 17.96875 25.078125 L 31.953125 25.078125 C 32.1875 25.078125 32.421875 25 32.5 24.84375 C 32.65625 24.6875 32.8125 24.453125 32.8125 24.21875 L 32.8125 14.0625 C 32.8125 13.59375 32.5 13.28125 32.03125 13.28125 L 30.78125 13.28125 C 30.3125 13.28125 30.15625 12.96875 30.078125 12.8125 C 30 12.734375 29.921875 12.34375 30.15625 11.953125 L 34.609375 6.5625 C 34.84375 6.328125 35.078125 6.25 35.234375 6.25 C 35.390625 6.25 35.625 6.25 35.859375 6.5625 L 40.3125 11.953125 C 40.625 12.34375 40.46875 12.65625 40.46875 12.8125 Z M 40.46875 12.8125 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDolos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dolos.e913f7b3.svg";
export { ForwardRef as ReactComponent };